export default "__VITE_ASSET__BJsdrFUV__"